import clone from 'lodash/clone'

const init = () => {
    acceptors.creators = []
    acceptors.current = []
    acceptors.tag = {}
}

const reset = () => {
    acceptors.current = []
    acceptors.tag = {}
}

const transit = (ch: string) => {
    acceptors.creators.forEach(function (creator: any) {
        let acceptor = creator.createAcceptor(acceptors.tag)

        if (acceptor) {
            acceptors.current.push(acceptor)
        }
    })

    let _current = []
    acceptors.tag = {}

    for (let i = 0; i < acceptors.current.length; i++) {
        let _acceptor = acceptors.current[i]
        let acceptor = _acceptor.transit(ch)

        if (!acceptor.isError) {
            _current.push(acceptor)
            acceptors.tag[acceptor.tag] = acceptor
        }
    }
    acceptors.current = _current
}

const getFinalAcceptors = () => {
    return acceptors.current.filter(function (acceptor: any) {
        return acceptor.isFinal
    })
}

export const acceptors = {
    creators: [] as any,
    current: [] as any,
    tag: {} as any,
    init,
    reset,
    transit,
    getFinalAcceptors
}

export const Acceptors = () => {
    let acceptor = clone(acceptors)
    acceptor.init()
    return acceptor
}
